//import { Path } from '../routes'
import * as types from '../constants/Action_types'

const initialState = {
    interests: [],

}

export default function (state = initialState, action) {

    switch (action.type) {

        case types.GET_INTERESTS:
            return {
                ...state,
                interests: action.payload
            }
        default:
            return state
    }
}

